var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-clan-wrapper d-flex flex-column"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 h-100"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }